<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 20;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg {width} {height} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9 1.4375C4.5472 1.4375 0.9375 5.0472 0.9375 9.5C0.9375 13.9528 4.5472 17.5625 9 17.5625C13.4528 17.5625 17.0625 13.9528 17.0625 9.5C17.0625 5.0472 13.4528 1.4375 9 1.4375ZM12.5303 7.03033C12.8232 6.73744 12.8232 6.26257 12.5303 5.96967C12.2374 5.67678 11.7626 5.67678 11.4697 5.96967L9.00008 8.43927L7.65532 7.09465C7.3624 6.80177 6.88753 6.80178 6.59465 7.09469C6.30177 7.3876 6.30178 7.86246 6.59469 8.15532L7.93935 9.49992L7.71968 9.71968C7.42678 10.0126 7.42678 10.4874 7.71968 10.7803C8.01255 11.0732 8.48745 11.0732 8.78032 10.7803L9.00008 10.5606L9.2196 10.7801C9.51248 11.073 9.98738 11.073 10.2802 10.78C10.5731 10.4872 10.5731 10.0122 10.2802 9.71937L10.0607 9.49992L12.5303 7.03033Z"
		{fill}
	/>
</svg>
